module.exports = __webpack_public_path__ + "img/help4.2ff4c672.jpg";